export default __webpack_public_path__ + "static/media/mp3.1cdaf930.png";